import React, { useEffect } from 'react';
import Menu from '../Menubar/Menu';
import { Categories } from '../MainMenu/MenüSicht';

export default function Support ({ setSection }) {
  useEffect(() => {
    setSection('Support');
  }, [setSection]);
  
  return (
    <div className="next-to-menu">
    <Menu />
    <Categories>
      <div>
        <p>Hier stehen Dinge wie:</p>
        <ul>
          <li>Kontaktdaten zu vci</li>
          <li>Möglichkeit zum Absenden von Feedback/Anregungen/Fragen</li>
        </ul>
      </div>
    </Categories>
    </div>
  )
}